import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { DataMapName } from '@wix/thunderbolt-becky-types'
import { Catharsis } from '../types/catharsis.types'

export const singleTransaction = (
	catharsis: Catharsis,
	beckyModel: BeckyModel,
	usedDataMaps: Iterable<DataMapName>,
	runAndReport: <T>(fn: () => T, name: string) => T
) => {
	const { structure, data, shapeStore, ...environment } = beckyModel

	runAndReport(
		() =>
			catharsis.transaction(({ updateStructure, updateData, updateSvgString, updateEnvironment }) => {
				runAndReport(() => updateEnvironment(environment), 'catharsis-updateEnvironment')

				runAndReport(() => {
					for (const shapeId in shapeStore) {
						updateSvgString(shapeId, shapeStore[shapeId])
					}
				}, `catharsis-updateSvgString`)

				runAndReport(() => {
					for (const compId in structure) {
						updateStructure(compId, structure[compId])
					}
				}, `catharsis-updateStructure`)

				runAndReport(() => {
					for (const dataMapName of usedDataMaps) {
						for (const id in data[dataMapName]) {
							const dataItem = data[dataMapName][id]
							updateData(dataMapName, id, dataItem)
						}
					}
				}, `catharsis-updateData`)
			}, runAndReport),
		'catharsis.transaction'
	)
}
